import { DragDropContext, Droppable, type DropResult } from '@hello-pangea/dnd';
import { type CSSProperties, type FC, type ReactNode, useCallback } from 'react';

interface SortableListProps {
  droppableId: string;
  onReorder: (sourceIndex: number, destinationIndex: number) => void;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

const noopDragEnd = () => {};

const SortableList: FC<SortableListProps> = ({ droppableId, onReorder, disabled, className, style, children }) => {
  const handleDragEnd = useCallback(
    (result: DropResult) => {
      if (
        !result.destination ||
        result.source.index === result.destination.index ||
        result.destination.droppableId !== droppableId
      ) {
        return;
      }
      onReorder(result.source.index, result.destination.index);
    },
    [droppableId, onReorder]
  );

  return (
    <DragDropContext onDragEnd={disabled === true ? noopDragEnd : handleDragEnd}>
      <Droppable droppableId={droppableId} isDropDisabled={disabled === true}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className={className} style={style}>
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SortableList;
